<template>
    <div class="index-container" ref="wrap">
        <Header :nosearch="true" :title="`股圈观点`" :height="44" />
        <div class="content-wrap">
            <div class="user-info-box">
                <img :src="detail.creator.image" alt="" />
                <p class="tab-title">{{ detail.creator.nickName }}</p>
            </div>
            <div class="detail-wrap">
                <div class="detail-title-box">
                    <p
                        class="title"
                        v-html="transCode2ImgFn(detail.title, 'mobile')"
                    ></p>
                    <div>
                        <span class="des" style="margin-right: 12px">{{
                            detail.createTime | showtime
                        }}</span>
                        <span class="des">阅读量：{{ detail.hitCount }}</span>
                    </div>
                </div>
                <div
                    class="detail-content"
                    v-html="transCode2ImgFn(detail.newsBean.content, 'mobile')"
                ></div>
                <div
                    class="pic-content"
                    v-if="
                        detail.newsBean.medias && detail.newsBean.medias.length
                    "
                >
                    <img :src="detail.newsBean.medias[0].address" />
                </div>
                <div class="des-box">
                    声明：用户发表的所有言论等仅代表个人观点，与本网站立场无关，不对您构成任何投资建议。
                </div>
            </div>
            <div class="comment-warp">
                <p class="title">评论 {{ totalCount }}</p>
                <div class="comment-item-box">
                    <div
                        v-for="(item, index) in list"
                        :key="index"
                        class="comment-item"
                    >
                        <div
                            :class="
                                index === list.length - 1
                                    ? 'item-content no-border'
                                    : 'item-content'
                            "
                        >
                            <div class="reviewer-info">
                                <img :src="item.reviewCeator.image" alt="" />
                                <p class="tab-title">
                                    {{ item.reviewCeator.nickName }}
                                    <span v-if="item.isAuthor === 1"
                                        >（作者）</span
                                    >
                                </p>
                            </div>
                            <div>
                                <!-- <p class="wrap-line" v-html="item.reviewContext"></p> -->
                                <p
                                    class="wrap-line"
                                    v-html="
                                        transCode2ImgFn(
                                            item.reviewContext,
                                            'mobile'
                                        )
                                    "
                                ></p>
                                <div
                                    class="parent-content wrap-line"
                                    v-if="item.parentContext"
                                >
                                    <div class="parent-content-name">
                                        {{ item.parentCeator.nickName
                                        }}<span v-if="item.isAuthor === 1"
                                            >（作者）</span
                                        >:
                                    </div>
                                    <div
                                        class="parent-content-context"
                                        v-html="
                                            transCode2ImgFn(
                                                item.parentContext,
                                                'mobile'
                                            )
                                        "
                                    ></div>
                                </div>
                            </div>
                            <div class="tab-label">
                                <span>
                                    {{ item.createTime | showtime }}
                                    <span
                                        v-if="getShowReviewBtn(item)"
                                        class="review-text"
                                        @click="clickReview(item)"
                                        >回复</span
                                    >
                                </span>
                                <div
                                    class="icon-box"
                                    @click="supportViewApi(item, index)"
                                >
                                    <span>{{ item.supportCount }}</span>
                                    <img
                                        v-if="item.isSupport === 0"
                                        class="awesome-icon"
                                        src="@/assets/icon-awesome-gray.png"
                                    />
                                    <img
                                        v-else
                                        src="@/assets/icon-awesome.png"
                                        class="awesome-icon"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-data" v-if="list.length === 0">
                        <img src="@/assets/no_content.png" alt="" />
                        <p>暂无评论</p>
                        <p>赶快抢个沙发</p>
                    </div>
                    <infinite-loading
                        ref="gubainf"
                        @infinite="infiniteHandler"
                        direction="bottom"
                        :distance="100"
                        :forceUseInfiniteWrapper="true"
                    >
                        <div slot="no-more" class="no-more-list">
                            我也是有底线的
                        </div>
                        <div
                            v-if="list.length === 0"
                            slot="no-results"
                            class="no-results"
                        ></div>
                        <div v-else slot="no-results"></div>
                        <div slot="spinner" class="tab-spinner">
                            正在加载...
                        </div>
                    </infinite-loading>
                </div>
            </div>
            <div v-show="!showReplyAuth" class="detail-footer">
                <div class="footer-content">
                    <div v-show="!showReplyAuth" class="no-focus">
                        <p
                            @click="clickSendAuthor"
                            v-html="replyAuthContent || '我来说两句～'"
                        ></p>
                        <div @click="supportDetailApi" class="footer-awasome">
                            <img
                                v-if="detail.newsBean.isSupport === 0"
                                class="footer-awesome-icon"
                                src="@/assets/icon-awesome-gray.png"
                            />
                            <img
                                v-else
                                src="@/assets/icon-awesome.png"
                                class="footer-awesome-icon"
                            />
                            <span>{{ detail.supportCount }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ReplyAuth
            v-show="showReplyAuth"
            :newsId="newsId"
            :closeReplyAuth="closeReplyAuth"
            :submitSuccess="submitSuccess"
        />
        <ReplyCreator
            v-if="showReplyCreator"
            :newsId="newsId"
            :closeReplyCreator="closeReplyCreator"
            :submitSuccess="submitSuccess"
            :currentSelectedCreator="currentSelectedCreator"
        />
        <Toast v-if="showToast" :text="toastText"></Toast>
    </div>
</template>

<script type="text/ecmascript-6">
import moment from 'moment'
import { mapState } from 'vuex'

import Header from '@/components/header.vue'
import Toast from '@/components/toast.vue'
import InfiniteLoading from 'vue-infinite-loading'

import ReplyAuth from './replyAuth'
import ReplyCreator from './replyCreator'
import RHEmoji, { transCode2ImgFn } from '../../../components/rhEmoji/index'

import { request } from '@/api/request'
import { publishDetail, supportReview, support, unSupportReview, unSupport } from '@/api'

export default {
    components: { Header, Toast, InfiniteLoading, ReplyAuth, ReplyCreator },
    data() {
        return {
            showToast: false,
            newsId: this.$route.params.id,
            pageNo: 1,
            showReplyAuth: false,
            showReplyCreator: false,
            currentSelectedCreator: {},
            actionLock: false,
            replyAuthContent: '',
            detail: {
                title: '',
                creator: {
                    title: '',
                    cTime: new Date(),
                    image: '',
                    nickName: ''
                },
                hitCount: 0, // 阅读
                reviewCount: 0, // 评论
                supportCount: 0, // 点赞
                newsBean: {
                    content: '',
                    isSupport: 0,
                    medias: []
                },
            },
            list: [],
            toastText: '',
            scrollTop: 0,
            totalCount: 0,
        }
    },
    computed: {
        ...mapState(['code', 'market', 'stockname', 'userInfo'])
    },
    filters: {
        showtime(_date) {
            let day = moment(new Date())
            let date = moment(_date)
            if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
                return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
            } else if (day.year() === date.year()) {
                return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
            } else {
                return `${date.year()}-${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
            }
        },
    },
    activated() {
        this.$refs.gubainf.stateChanger.reset()
    },
    created() {
        this.getDataApi()
    },
    mounted() {
        console.log(this.userInfo)
    },
    methods: {
        transCode2ImgFn,
        scroll() {
            this.scrollTop = this.$refs.wrap.scrollTop
        },
        async infiniteHandler($state) {
            let canload = await this.getListApi()
            if (canload) $state.loaded()
            else $state.complete()
        },
        async getDataApi() {
            const params = {
                token: this.userInfo.token,
                serverId: this.userInfo.serverId,
                appCode: '9fztgw',
                newsId: this.newsId,
                pageNo: 1,
                pageSize: 10
            }
            const res = await request.get({ url: request.apis.stockBar.detail, params })
            if (res) {
                this.detail = res
            }
        },
        async getListApi() {
            let params = {
                token: this.userInfo.token,
                serverId: this.userInfo.serverId,
                appCode: '9fztgw',
                newsId: this.newsId,
                pageNo: this.pageNo++,
                pageSize: 20
            }
            const res = await request.get({ url: request.apis.stockBar.reviewList, params })
            const { code, data, totalCount } = res
            if (code === 1) {
                this.list = this.list.concat(data)
                this.totalCount = totalCount
                if (data.length > 0) return true
            } else {
                return false
            }
        },
        async supportDetailApi() {
            if (this.actionLock) return

            const isLogin = this.isLogin()
            if (!isLogin) return

            const params = {
                token: this.userInfo.token,
                serverId: this.userInfo.serverId,
                newsId: this.newsId
            }
            this.actionLock = true
            let res = this.detail.newsBean.isSupport === 0 ? await support(params) : await unSupport(params)
            if (res.code === 1) {
                this.actionLock = false
                // 处理点赞总数
                this.detail.supportCount = this.detail.newsBean.isSupport === 0 ? this.detail.supportCount + 1 : this.detail.supportCount - 1

                // 处理自己是否点击的图标
                this.detail.newsBean.isSupport = 1 - this.detail.newsBean.isSupport
            }
        },
        async supportViewApi(item, index) {
            if (this.actionLock) return

            const isLogin = this.isLogin()
            if (!isLogin) return false

            const { reviewId, isSupport } = item
            const params = {
                token: this.userInfo.token,
                serverId: this.userInfo.serverId,
                newsId: this.newsId,
                reviewId
            }
            this.actionLock = true
            let res = isSupport === 0 ? await supportReview(params) : await unSupportReview(params)
            const url = isSupport === 0 ? request.apis.stockBar.supportReview : request.apis.stockBar.unSupportReview
            if (res.code === 1) {
                this.actionLock = false
                // this.getListApi()
                this.list[index].isSupport = isSupport === 0 ? 1 : 0
                this.list[index].supportCount = isSupport === 0 ? this.list[index].supportCount + 1 : this.list[index].supportCount - 1
            }
        },
        isLogin() {
            if (!this.userInfo.token) {
                // this._toast('请登录')
                // setTimeout(() => {
                //     this.$router.push(`/login.html?redirect=${this.$route.path}`)
                // }, 3000)
                this.$router.push(`/login.html?redirect=${this.$route.path}`)
                return false
            }
            return true
        },
        clickSendAuthor() {
            const isLogin = this.isLogin()
            if (!isLogin) return false
            this.showReplyAuth = true
        },
        getShowReviewBtn(item) {
            if (this.userInfo && this.userInfo.username === item.reviewCeator.userCode) return false
            return true
        },
        clickReview(item) {
            const isLogin = this.isLogin()
            if (!isLogin) return false
            this.currentSelectedCreator = item
            this.showReplyCreator = true
        },
        _toast(toastText, time = 3000) {
            this.toastText = toastText
            this.showToast = true
            setTimeout(() => {
                this.showToast = false
            }, time)
        },
        closeReplyAuth(html) {
            this.replyAuthContent = html
            this.showReplyAuth = !this.showReplyAuth
        },
        closeReplyCreator() {
            this.currentSelectedCreator = {}
            this.showReplyCreator = !this.showReplyCreator
        },
        submitSuccess(type) {
            this.showReplyAuth = false
            this.showReplyCreator = false
            this.currentSelectedCreator = {}
            this.list = []
            this.pageNo = 1
            this.$refs.gubainf.stateChanger.reset()

            if (type === 'auth') {
                this.replyAuthContent = ''
            }

            this._toast('评论已提交，将在审核完毕后发布')
        }
    }
}
</script>

<style lang="stylus" scoped>
.wrap-line
    word-wrap break-word
    word-break normal

.des-color
    color #999999

.red-color
    color #E94041

.no-more-list
    height 60px
    line-height 60px
    background #F5F5F5
    font-size 14px
    font-weight 400
    color #999999
    position relative

    &:before
        content ' '
        height 0
        width 26px
        border none
        border-top 1px solid #DCDCDC
        position absolute
        left 103px
        top 30px

    &:after
        content ' '
        height 0
        width 26px
        border none
        border-top 1px solid #DCDCDC
        position absolute
        right 104px
        top 30px

.send-btn
    width 86px
    height 32px
    line-height 32px
    text-align center
    background #F43737
    color #fff
    border-radius 2px

    &.disable
        background #DCDCDC

.flex-box
    display flex
    justify-content space-between

.bg
    width 100%
    height 100vh
    position fixed
    left 0
    bottom 0
    background rgba(0, 0, 0, 0.5)

.input-box *, .content-wrap div
    box-sizing border-box

.content-wrap
    padding-top 44px

.awesome-icon
    width 15px
    height 14px
    margin-left 4px
    margin-top -2px

.icon-box
    display flex
    justify-content space-between
    align-items center

.index-container
    // height 100vh
    overflow-y auto
    background #f5f5f5

.detail-wrap
    padding 12px
    background #fff
    margin-bottom 12px

    .detail-title-box
        border-bottom 1px solid #F5F5F5
        padding-bottom 12px

    .detail-content
        padding 8px 0
        color #333333
        font-size 16px
        line-height 28px
        margin-bottom 12px

    .des-box
        padding 8px 12px
        font-size 12px
        color #bbb
        background #FAFAFA

    .title
        font-size 17px
        color #333
        font-weight 500
        margin-bottom 12px
        line-height 25px

    .des
        color #999999
        font-size 12px
        line-height 17px

.user-info-box
    padding 12px 12px 0 12px
    font-size 15px
    background #f5f5f5
    display flex
    align-items center
    color #999999
    background #fff

    img
        width 34px
        height 34px
        border-radius 50%
        margin-right 12px

    p
        width 0
        flex 1
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        font-size 15px
        color #999
        line-height 18px

.reply-footer
    display flex
    justify-content space-between
    align-items center

    .emoji-icon
        >img
            width 26px
            height 26px

    .send-btn
        width 86px
        height 32px
        line-height 32px
        display inline-block
        text-align center
        background #F43737
        color #fff
        border-radius 2px

        &.disable
            background #DCDCDC

.comment-warp
    font-size 15px
    background #fff
    padding-bottom 57px

    .title
        padding 6px 12px
        font-size 15px
        font-weight 600
        color #333333
        line-height 21px
        border-bottom 1px solid #EDEFF3

    .comment-item
        padding 0 12px

        .item-content
            padding 12px 0
            border-bottom 1px solid #F5F5F5

            &.no-border
                border none

            .reviewer-info
                display flex
                justify-content flex-start
                align-items center
                margin-bottom 4px

                img
                    width 30px
                    height 30px
                    border 1px solid #DEDEDE
                    border-radius 50%
                    margin-right 8px

                p
                    font-size 15px
                    font-weight 400
                    color #999999
                    line-height 18px

            .wrap-line
                font-size 16px
                font-weight 400
                color #333333
                line-height 22px

        .tab-label
            display flex
            justify-content space-between
            font-size 12px
            color #999
            margin-top 10px
            line-height 17px

            .review-text
                font-size 12px
                font-weight 400
                color #7AA5D2
                line-height 17px
                margin-left 12px

    .parent-content
        padding 5px 7px
        background #F5F5F5
        margin 5px 0

        .parent-content-name
            display inline
            color #333
            font-size 14px
            line-height 22px

        .parent-content-context
            display inline
            color #666
            font-size 14px
            line-height 22px

.detail-footer
    width 100%
    position fixed
    bottom 0
    left 0
    background #fff

    *
        box-sizing border-box

    .footer-content
        background #fff
        border-top 1px solid #F2F5F8

    > div
        background #fff
        padding 10px 16px
        box-sizing border-box

    .bg
        width 100%
        height 100vh
        z-index -1

    .no-focus
        box-sizing border-box
        display flex
        height 36px
        line-height 36px
        color #999999
        font-size 15px

        p
            flex 1
            padding 0 14px
            background #F5F5F5
            cursor pointer
            border-radius 2px
            margin-right 16px
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
            -o-text-overflow ellipsis

    .footer-awasome
        min-width 28px
        display flex
        justify-content center
        align-items flex-start

        .footer-awesome-icon
            width 21px
            height 20px
            align-self center

        span
            font-size 10px
            font-weight 400
            color #999999
            line-height 14px

.input-box
    position fixed
    top 0
    left 0
    width 100%
    height 100%
    z-index 1

    .bg
        background rgba(0, 0, 0, 0.5)

    .review-creator
        width 100%
        position absolute
        top 30px
        padding 12px
        background-color #fff

.no-data
    padding-bottom 50px

    img
        display block
        margin 20px auto
        width 200px

    p
        font-size 12px
        text-align center
        color #999999

.pic-content
    margin -10px 0 10px
</style>

<style lang="stylus">
.detail-wrap
    .rhemoji-emo, .rhemoji-emo-mobile
        width 28px
        height 28px
        margin-top -3px
</style>